import React from 'react'
import SbEditable from 'storyblok-react'
import Headline from '../atoms/Headline'

const HeaderBlock = ({ block, className }) => {
  return (
    <SbEditable content={block}>
      {(block.kicker?.length > 0 ||
        block.headline?.length > 0 ||
        block.subheadline?.length > 0) && (
        <section
          className={`header-block ${className} ${
            block.space_top ? block.space_top : ''
          } ${block.space_bottom ? block.space_bottom : ''}`}
        >
          <div className="header-block-content">
            <Headline
              kicker={block.kicker}
              headline={block.headline}
              subheadline={block.subheadline}
              headline_level={block.headline_level}
            />
          </div>
        </section>
      )}
    </SbEditable>
  )
}

export default HeaderBlock
